<template>
  <div v-if="model">
    <component
      :is="currentComponent"
      v-bind="props"
    />
    <slot />
  </div>
</template>

<script>
import DNDCardsGrid from '@/core/components/DNDCardsGrid.vue';
import SimpleCardsGrid from '@/core/components/SimpleCardsGrid.vue';

export default {
  name: 'Generic',
  components: {
    DNDCardsGrid,
    SimpleCardsGrid,
  },
  props: {
    model: {
      type: Object,
      required: true,
      default: null,
    },
    isDNDActivated: {
      type: Boolean,
      required: true,
      default: false,
    },
    entityType: {
      required: true,
      type: String,
    },
  },
  computed: {
    currentComponent() {
      return this.isDNDActivated
        ? DNDCardsGrid
        : SimpleCardsGrid;
    },
    props() {
      return {
        type: this.entityType,
        model: this.model,
        showContent: this.showContent,
      };
    },
  },
};
</script>